module.exports = __webpack_public_path__ + "static/media/1421138632_frozen-480x800.306b00fd.jpg";